/**
 * Chart relationship helpers and empty fallbacks when Medplum chart data is absent.
 */
import type { Appointment, Episode } from '../pages/clients/data/types';
import type { ChartSharedRelationship, ClientChartBundle } from '../pages/clients/data/clientChartBundle';

export type { ClientChartBundle, ChartSharedRelationship };

/** @deprecated Use FHIR-linked relationships; kept for type compatibility during mock removal. */
export type MockRelationship = ChartSharedRelationship;

export const mockRelationships: ChartSharedRelationship[] = [];

function emptyBundle(): ClientChartBundle {
  return {
    appointments: [],
    clinicalNotes: [],
    adminNotes: [],
    episodes: [],
    medications: [],
    dischargeSummaries: [],
    assessments: [],
    assessmentTrends: [],
    healthMetrics: [],
    completedForms: [],
    documents: [],
    historicalRecords: [],
    tasks: [],
    outstandingForms: [],
    pendingFormTasks: [],
  };
}

export function getClientChartData(_clientId: string): ClientChartBundle {
  return emptyBundle();
}

export function getRelationshipForAppointment(
  _appointmentId: string,
): ChartSharedRelationship | undefined {
  return undefined;
}

export function getClientAppointments(_clientId: string): Appointment[] {
  return [];
}

export function getClientEpisodes(_clientId: string): Episode[] {
  return [];
}
